module.exports = Object.keys || require('./shim');




//////////////////
// WEBPACK FOOTER
// ./~/object-keys/index.js
// module id = 559
// module chunks = 0